import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Modal, Icon, Button } from 'semantic-ui-react'
import MediaQuery from 'react-responsive'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
//import Fuse from 'fuse.js'

import Config from './Config'
import ListaEventos from '../src/components/Eventos/ListaEventos'
import Eventos from '../src/services/Eventos'
import Helper from '../src/components/Sistema/Helper'
import Usuarios from '../src/services/Usuarios'
import DetalheCongresso from '../src/components/Congresso/DetalheCongresso'
import Mensagem from '../src/components/Sistema/Mensagem'
import Loader from '../src/components/Sistema/Loader'
import Login from '../src/components/Usuarios/Login'
import PesquisaEventos from '../src/components/Eventos/Pesquisa/PesquisaEventos'
import { Titulo1 } from '../src/components/Layout/Titulo'
import Mensagens from './Mensagens'

import IsDevIndicator from '../src/components/Ambiente/IsDevIndicator'

class PageEventos extends React.Component {

  eventosListRef = React.createRef()
  topRef = React.createRef()

  container = null

  constructor(props) {
    super(props)

    if(this.props.match.params.id != undefined){
      Eventos.setIdCongresso(this.props.match.params.id)
    }
    
    if(this.props.match.params.c != undefined){
      Usuarios.setCurrentUser({congressistaToken:this.props.match.params.c})
    }
    
    if(this.props.match.params.t != null && this.props.match.params.t.length > 0){
      Eventos.setIdCongresso(this.props.match.params.t.split(".")[1])
    }
    
    this.state = {
      eventos: [],
      congresso: null,
      congressista: null,
      inicio: 0,
      fim: 50,
      order: 'datac',
      loading: true,
      icTodosEventos: false,
      exibirSoHoje: false,
      exibirTodos: false,
      exibirInscritas: false,
      erro: false,
      modalOpen: false,
      evento: undefined,
      hasFiltro: false,
      eventosCongressista: [],
      messageInscricoes: '',
      icPresencaMarcada: false,
      icJaFazLogoutPeloQrCode: false,
      idEventoCongressoPorQrCode: this.props.match.params.t != null && this.props.match.params.t.length > 0 ? this.props.match.params.t.split(".")[0] : "",
      tokenQrCode: this.props.match.params.t == "" || this.props.match.params.t == undefined ?  "" : this.props.match.params.t.split(".")[0],
      
      /*login */
      loginParameters: {
        tipoLogin: 1,//1 - inscrição, 2- certificado
        loginOption: 0,
        loginTitle: Mensagens.m4,
        lblBtnLogin: Mensagens.b3,
        loginMessage: '',
        loginMessageList: '',
        icPermiteCancelar: false,
      },

      /*avaliação NPS*/
      icAvaliacaoNPS: false,
      eventosNPS: [],
      loadingEventos: false,
      nuEventosNaoAvaliados: 0,

      participante: undefined,
      todosEventos: [],
      filterKeys: [],
      searchTerm: '',
      icSemInscricoes: false
    }
  }

  render() {

    const eventHandlers = {
      onLogin: (u, p, c) => this.handleSucessoLogin(u, p, c),
      onHandleInscricao: (e) => this.handleInicioInscricao(e),
      onHandleExclusao: (e) => this.handleExclusao(e),
      onEndAvaliacaoNPS: (e) => this.handleEndAvaliacaoNPS(e),
    }
    const eventHandlersPesquisa = {
      onChangeOrder: (v) => this.onChangeOrder(v),
      onChangeCheck: (y, z) => this.onChangeCheck(y, z),
      onSelectTag: (k, v) => this.onSelectTag(k, v),
      onSearch: (v, i) => this.onSearch(v, i)
    }
    const switchDefaultValues = {
      exibirSoHoje: this.state.exibirSoHoje,
      exibirTodos: this.state.exibirTodos,
      exibirInscritas: this.state.exibirInscritas,
    }

    var linkLogout = <Link to={`/${Eventos.getIdCongresso()}`} onClick={() => this.handleLogout()}>
      Sair <Icon name='log out' />
    </Link>

    return <div>

      <header>
        <div className="container">
          {this.state.congresso !== null &&
            <div className='mtop10'>

              <h1>{this.state.congresso.deTitulo}</h1>
              <div ref={this.topRef}>
                <span className='strong'>
                  <Icon name='calendar alternate outline' />
                  Período:
                </span>
                {` ${this.state.congresso.dtInicioCongresso} a ${this.state.congresso.dtFimCongresso}`}
              </div>
              <div className='mtop10'>
                <span className='strong'>
                  {this.state.congresso.icInscricoesAbertas &&
                    <Icon name='calendar check outline' />
                  }
                  {!this.state.congresso.icInscricoesAbertas &&
                    <Icon name='calendar times outline' />
                  }
                  Inscrições:
                </span>
                {` ${this.state.congresso.dtInicioInscricao} a ${this.state.congresso.dtFimInscricao}`}
              </div>
              <IsDevIndicator content={`${Config.API_URL} - ${this.state.congresso.idCongresso}`}></IsDevIndicator>

            </div>
          }
        </div>

        {/* {Helper.isDevEnvironment() &&
          <div className='teste'>
            <Segment raised>
              

              <p>{Mensagens.m5}</p>
              <p>Fonte de dados: {Config.API_URL}</p>
            </Segment>
          </div>
        } */}

      </header>
      <div className='main-content tipoPart quaseLa' >

        <div className='container'>


          {this.state.erro &&
            <Mensagem
              error
              Header={Mensagens.m36}
              Content={Mensagens.m6} />

          }
          {Eventos.getIdCongresso() === null &&
            <Mensagem
              error
              Header={Mensagens.m7}
              Content={Mensagens.m8} />
          }


          {Eventos.getIdCongresso() !== null &&
            <div>
              <DetalheCongresso congresso={this.state.congresso}
                congressista={this.state.congressista}
                eventos={this.state.todosEventos}
                eventosCongressista={this.state.eventosCongressista}
                onDownloadCracha={() => this.handleDownloadCracha()}
                onDownloadComprovante={() => this.handleDownloadComprovante()}
                onDownloadCertificado={(e) => this.handleCertificado(e)}
                linkLogout={linkLogout} />
              {
                this.state.congresso &&
                <div>
                  {(this.state.eventos && this.state.eventos.length === 0) &&
                    <div>
                      <Titulo1 content={this.props.textoSemDados} />
                    </div>}

                  <PesquisaEventos
                    eventos={this.state.todosEventos}
                    eventHandlers={eventHandlersPesquisa}
                    filtros={this.state.filterKeys}
                    switchDefaultValues={switchDefaultValues}
                    icSwitchInscritos={this.state.eventosCongressista && this.state.eventosCongressista.length > 0} />

                  <div ref={this.eventosListRef} >
                    {((!this.state.eventos || this.state.eventos.length === 0) && !this.state.loading) &&
                      <Mensagem
                        warning
                        Header={Mensagens.m36}
                        Content={Mensagens.m9} />
                    }
                  </div>
                  {(this.state.eventos && this.state.eventos.length > 0) &&
                    <ListaEventos
                      titulo={`Atividades (${this.state.eventos.length})`}
                      source={this.state.eventos}
                      eventHandlers={eventHandlers} />
                  }

                </div>

              }
              {this.state.icTodosEventos &&
                <Mensagem
                  info
                  Header={Mensagens.m10}
                  Content={Mensagens.m11} />
              }
              <Loader loading={this.state.loading}>{Mensagens.m12}</Loader>
            </div>
          }
          <MediaQuery maxWidth={800}>
            {(this.state.eventos && this.state.eventos.length > 0) &&
              <Button className='type2' floated='right' onClick={() => window.scrollTo(0, this.topRef.current.offsetTop)} >Ir para o topo <Icon name='chevron up' /></Button>
            }
          </MediaQuery>
        </div>

        <Modal
          closeOnEscape={false}
          closeOnDimmerClick={false}
          open={this.state.modalOpen}
          onClose={() => this.handleClose()}
          dimmer='inverted'>
          <Modal.Content className='resetCorners resetBorders' >
            <Modal.Description className='resetCorners resetBorders'>
              <div className='main-content tipoPart modal' >
                {this.state.icAvaliacaoNPS &&
                  <div className='main-content tipoPart modal'>
                    <div className='container'>

                      {this.state.icSemInscricoes &&
                        <Mensagem
                          info
                          Header={Mensagens.m13}
                          Content={Mensagens.m14} />
                      }
                      <Loader loading={this.state.loadingEventos}></Loader>
                      {!this.state.icSemInscricoes &&
                        <ListaEventos
                          icExibeNPS={true}
                          titulo={Mensagens.m15}
                          textoSemDados={Mensagens.m16}
                          eventHandlers={eventHandlers}
                          htmlSubtitle={{ __html: `<p><span className='strong'>${Mensagens.m17}</span> </p>${Mensagens.m18}` }}
                          source={this.state.eventosNPS} />
                      }
                    </div>
                  </div>
                }
                {
                  !this.state.icAvaliacaoNPS &&

                  <Login loginParameters={this.state.loginParameters}
                    onCancel={() => this.handleClose()}
                    onLogin={(u, p, o, c) => this.handleLogin(u, p, o, c)}
                    cadastroOptions={this.state.participante} />
                }
              </div>
            </Modal.Description>
          </Modal.Content>
        </Modal>
        <ToastContainer position="top-right" />

      </div>


    </div>
  }

  componentDidMount() {
    
    if(this.state.idEventoCongressoPorQrCode !== '' && this.state.idEventoCongressoPorQrCode !== undefined){
      if(this.state.icJaFazLogoutPeloQrCode === false ){
        Usuarios.logout()

        this.setState({
          ...this.state,
          icJaFazLogoutPeloQrCode: true
        })
      }

      var ids = this.props.match.params.t.split(".");
      Eventos.setIdCongresso(ids[1]);
    }
    this.carregarCongresso()

    window.addEventListener("scroll", () => {
      if (!this.state.hasFiltro && Helper.isBottomPage() && !this.state.loading) {
        this.atualizarEventos()
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", Helper.isBottomPage);
  }

  handleDownloadCracha() {
    toast.info(<Mensagem toastr
      Header={Mensagens.m19}
      Content={Mensagens.m20} />);

    Eventos.getCracha().then((result) => {

      if (result.sucesso) {
        toast.success(<Mensagem toastr
          Header=''
          Content={result.Mensagem} />);
      }
      else {
        toast.error(<Mensagem toastr
          Header={Mensagens.m36}
          Content={Mensagens.m21} />);
      }
    })

  }

  handleDownloadComprovante() {
    toast.info(<Mensagem toastr
      Header='Aguarde...'
      Content='O download do seu comprovante irá começar em alguns segundos' />);

    Eventos.getComprovante().then((result) => {

      if (result.sucesso) {
        toast.success(<Mensagem toastr
          Header=''
          Content={result.Mensagem} />);
      }
      else {
        toast.error(<Mensagem toastr
          Header={Mensagens.m36}
          Content={Mensagens.m22} />);
      }
    })
  }

  onSearch = (value, goToSearchItems) => {

    this.setState({
      ...this.state,
      searchTerm: value,
      hasFiltro: true
    },

      () => {
        if (!goToSearchItems)
          this.filtrarEventos()
      }
    )

    if (this.state.searchTerm && goToSearchItems) {
      window.scrollTo(0, this.eventosListRef.current.offsetTop)
      this.filtrarEventos()

    }
  }
  onSelectTag = (key, value) => {

    var filters = this.state.filterKeys;

    filters.forEach(item => {
      if (item.key === key && item.value === value)
        item.selected = true;
      else
        item.selected = false;
    })

    this.setState({
      ...this.state,
      filterKeys: filters,
      exibirSoHoje: false,
      exibirTodos: false,
      exibirInscritas: false
    }, () => {
      this.filtrarEventos()
    })
  }

  onChangeOrder = (order) => {

    this.setState({
      ...this.state,
      order: order,
      eventos: []
    }, () => {
      this.carregarEventos()
    })
  }
  onChangeCheck = (name, value) => {

    var tags = this.state.filterKeys

    tags.forEach(item => { item.selected = false })

    this.setState({
      ...this.state,
      exibirSoHoje: false,
      exibirTodos: false,
      exibirInscritas: false,
      filterKeys: tags
    }, () => {
      this.setState({
        ...this.state,
        [name]: value,

      }, () => {
        this.filtrarEventos()
      })
    })
  }

  filtrarEventos() {

    let eventoExibir = []

    this.setState({
      ...this.state,
      loading: true,
      hasFiltro: true,
      evento: []
    }, () => {

      var tags = this.state.filterKeys.filter(x => x.selected)

      if (this.state.exibirSoHoje) {
        let hoje = `${new Date().getDate()}/${new Date().getMonth() + 1}/${new Date().getFullYear()}`
        eventoExibir = this.state.todosEventos.filter((item) => { return item.dtInicio === hoje })
      }
      else if (this.state.exibirInscritas) {
        eventoExibir = this.state.todosEventos.filter((item) => { return item.icInscrito })
      }
      else if (this.state.exibirTodos) {
        eventoExibir = this.state.todosEventos;
      }
      else if (tags.length > 0) {
        //tags sempre só terá um selecionado
        tags.forEach(item => {
          eventoExibir = this.state.todosEventos.filter(x => x[item.key] === item.value)
        })
      }
      else if (this.state.searchTerm !== '') {

        var termo = this.state.searchTerm.toLowerCase().trim();

        eventoExibir = this.state.todosEventos.filter((item) => {
          return item.deTituloEvento.toLowerCase().includes(termo)
            || item.deLocalEvento.toLowerCase().includes(termo)
            || item.nmCurso.toLowerCase().includes(termo)
        })
      }
      else {
        this.setState({
          ...this.state,
          hasFiltro: false
        }, () => {
          eventoExibir = this.state.todosEventos.slice(this.state.inicio, this.state.fim)
        })
      }
      
      this.exibirEventos(eventoExibir)
    })


  }

  setHighlightTerm(item, property, x) {

    if (item[property].toLowerCase().includes(x.toLowerCase())) {

      var inicio = item[property].toLowerCase().indexOf(x.toLowerCase())
      var fim = inicio + x.length
      var palavra = item[property].substring(inicio, fim)

      item[property] = item[property].replace(palavra, '<span class="highlight">' + palavra + '</span>')
    }
  }

  carregarCongresso() {

    Eventos.getCongresso()
      .then(response => {

        if (!response.sucesso) {
          this.setState({
            ...this.state,
            erro: true,
            loading: false
          })
          return
        }

        this.setState({
          ...this.state,
          congresso: response.data,
        }, () => {

          let loginOptions = []
          if (this.state.congresso.icAlunoUniCEUB)
            loginOptions.push({ key: 'a', text: Mensagens.p19, value: 1 })
          if (this.state.congresso.icProfessorFuncionario)
            loginOptions.push({ key: 'b', text: Mensagens.p20, value: 2 })
          if (this.state.congresso.icExterno)
            loginOptions.push({ key: 'c', text: Mensagens.p21, value: 3 })

          let m = `A data da inscrição do evento é de ${this.state.congresso.dtInicioInscricao} a ${this.state.congresso.dtFimInscricao}.`

          let l = this.state.loginParameters
          l.loginOptions = loginOptions
          l.loginMessage = this.state.congresso.icInscricoesAbertas ? '' : m

          l.icPermiteCancelar = !this.state.congresso.icInscricoesAbertas

          this.setState({
            ...this.state,
            loginParameters: l,
            modalOpen: !Usuarios.isAuthenticated(),
            messageInscricoes: m,
          })

          this.carregarEventos()
          this.carregarCongressista()

        })
      })
  }

  carregarCongressista() {


    if (Usuarios.isAuthenticated()) {

      Eventos.getCongressista().then(response => {

        if (!response.sucesso) {
          this.setState({
            ...this.state,
            erro: true,
            loading: false
          })
          return
        }

        if (response.data.idCongressoEncrypted !== Eventos.getIdCongresso()) {
          
          Usuarios.logout()
          response.data = null

        }

        this.setState({
          ...this.state,
          modalOpen: !Usuarios.isAuthenticated(),
          congressista: response.data
        }, () => this.carregarEventosCongressista())
      })
    }
  }

  carregarEventosCongressista() {

    if (!Usuarios.isAuthenticated())
      return

    Eventos.getInscricoesCongressista().then(result => {

      this.setState({
        ...this.state,
        eventosCongressista: result.data
      }, () => this.handlerPresenca())
    })
  }

  

  handlerPresenca = () => {
    if(this.state.congressista != null 
      && this.state.congressista != undefined
      && this.state.idEventoCongressoPorQrCode != undefined
      && this.state.idEventoCongressoPorQrCode != ''
      && Usuarios.isAuthenticated()) {
      Eventos.getIdEventoCongresso(this.state.idEventoCongressoPorQrCode).then(idEventoCongresso => {
        Eventos.jaMarcouPresenca(this.state.congressista.idCongressista, idEventoCongresso)
        .then(jaMarcou => {
          if(jaMarcou) {
            this.setState({
              ...this.state,
              icPresencaMarcada: true
            })
          }
          else {
            let user = Usuarios.getCurrentUser();
            this.props.history.push('/presenca/' + this.state.tokenQrCode+'/tipo/'+user.optLogin);
          }

        });
      });
    }
  }

  atualizarEventos() {

    let restante = this.state.todosEventos.length - (this.state.eventos ? this.state.eventos.length : 0);
    let end = (restante > 50 ? 50 : restante) + this.state.eventos.length;

    this.setState({
      ...this.state,
      loading: true,
      icTodosEventos: false,
      inicio: this.state.eventos.length,
      fim: end
    }, () => {

      if (this.state.eventos.length >= this.state.congresso.nuQuantidadeEventos) {
        this.setState({
          ...this.eventos,
          icTodosEventos: true,
          loading: false
        })
        return;
      }

      let ev = this.state.eventos.concat(this.state.todosEventos.slice(this.state.inicio, this.state.fim))
      this.exibirEventos(ev)
    })

  }

  exibirEventos(eventos) {
    setTimeout(() => {
      this.setState({
        ...this.state,
        eventos: eventos,
        loading: false
      })
    }, 100);
  }

  atualizarRegra(evento) {
    evento.lblBotaoExcluir = Mensagens.b4
    evento.lblBotaoInscrever = Mensagens.b5
    evento.isInscricaoDisabled = false
    evento.isExclusaoDisabled = false

    if (evento.icChoqueHorario) {
      evento.lblBotaoInscrever = Mensagens.b6
      evento.isInscricaoDisabled = true
    }

    if(!evento.icAtivo){
      evento.lblBotaoInscrever = Mensagens.b24
      evento.isInscricaoDisabled = true
    }

    if (evento.icEventoRealizado) {

      evento.isInscricaoDisabled = true
      evento.isExclusaoDisabled = true
      evento.lblBotaoExcluir = Mensagens.b7
      evento.lblBotaoInscrever = Mensagens.b7
    }

    if (evento.nuVagasDisponiveis === 0) {
      evento.lblBotaoInscrever = Mensagens.b8
      evento.isInscricaoDisabled = true
    }

    if (evento.icInscrito) {

      if (evento.icMarcadaPresenca) {
        evento.lblBotaoExcluir = Mensagens.b9
        evento.lblBotaoInscrever = Mensagens.b9
        evento.isInscricaoDisabled = true
        evento.isExclusaoDisabled = true

      }
      else {
        evento.lblBotaoInscrever = Mensagens.b10
        evento.isInscricaoDisabled = true
      }
    }

    if (!evento.icInscricaoAberta) {
      evento.lblBotaoInscrever = Mensagens.b11
      evento.lblBotaoExcluir = Mensagens.b11
      evento.isInscricaoDisabled = true
      evento.isExclusaoDisabled = true
    }

  }
  carregarEventos() {

    Eventos.getEventosCongresso(0, this.state.congresso.nuQuantidadeEventos, this.state.order)
      .then(response => {

        var array = []
        var o = {}
        var f = []

        response.forEach(item => {
          this.atualizarRegra(item)


          if (!item.isInscricaoDisabled && item.lblBotaoInscrever === Mensagens.b5) {
            item.icInscricaoLiberada = Mensagens.b12
            o = { key: 'icInscricaoLiberada', value: Mensagens.b12, selected: false, tipo: 0 }
            f = array.filter(x => x.key === o.key && x.value === o.value)
            if (f.length === 0)
              array.push(o)
          }

          let hoje = `${new Date().getDate()}/${new Date().getMonth() + 1}/${new Date().getFullYear()}`

          if (item.dtInicio === hoje) {
            item.icHoje = Mensagens.b13
            o = { key: 'icHoje', value: Mensagens.b13, selected: false, tipo: 1 }
            f = array.filter(x => x.key === o.key && x.value === o.value)
            if (f.length === 0)
              array.push(o)
          }

          if (item.nuVagasDisponiveis > 0) {
            item.icVagas = Mensagens.b14
            o = { key: 'icVagas', value: Mensagens.b14, selected: false, tipo: 2 }
            f = array.filter(x => x.key === o.key && x.value === o.value)
            if (f.length === 0)
              array.push(o)
          }

          if (item.nmCurso) {
            o = { key: 'nmCurso', value: item.nmCurso, selected: false, tipo: 3 }
            f = array.filter(x => x.key === o.key && x.value === o.value)
            if (f.length === 0)
              array.push(o)
          }

          if (item.deTurnoEvento) {
            o = { key: 'deTurnoEvento', value: item.deTurnoEvento, selected: false, tipo: 4 }
            f = array.filter(x => x.key === o.key && x.value === o.value)
            if (f.length === 0)
              array.push(o)
          }

          var ano = item.dtInicio.split('/')[2]
          var mesAno = `${item.mesEvento}/${ano}`
          item.mesAno = mesAno

          o = { key: 'mesAno', value: item.mesAno, selected: false, tipo: 5 }
          f = array.filter(x => x.key === o.key && x.value === o.value)

          if (f.length === 0)
            array.push(o)

        })

        array.sort((a, b) => { return a.tipo - b.tipo })

        this.setState({
          ...this.state,
          todosEventos: response,
          filterKeys: this.state.filterKeys.length === 0 ? array : this.state.filterKeys
        }, () => {
          this.atualizarEventos()
        })
      })
  }

  handleLogout() {

    if (this.state.congressista != null && this.state.eventosCongressista != null && this.state.eventosCongressista.length <= 0) {
      if (!window.confirm(Mensagens.m23))
        return;
    }

    Usuarios.logout()
    this.setState({
      ...this.state,
      congressista: null,
      nuPagina: 0,
      loading: true,
      eventosCongressista: [],
      eventos: [],
      modalOpen: !Usuarios.isAuthenticated(),
      icAvaliacaoNPS: false
    }, () => this.carregarEventos())
  }

  handleSucessoLogin = () => {

    this.setState({
      ...this.state,
      nuPagina: 0,
    }, () => {
      this.carregarEventos()
      this.carregarCongressista()
    })

    if (this.state.loginParameters.tipoLogin === 2 && Usuarios.isAuthenticated())
      this.carregarEventosNPS()

  }
  realizarInscricaoEvento = () => {
    return Eventos.realizarInscricaoEvento(this.state.evento.idEventoCongresso).then(result => {

      if (result.sucesso && !result.data.icExistente) {
        toast.success(<Mensagem toastr
          Header={Mensagens.m24}
          Content={Mensagens.m25} />);
      }
      else {
        toast.error(<Mensagem toastr
          Header={Mensagens.m36}
          Content={Mensagens.m26} />)
      }
    })
  }

  handleLogin = (username, password, option, participante) => {

    let idevento = this.state.evento ? this.state.evento.idEventoCongresso : 0


    return Eventos.handleInscricao(idevento, username, password, option, this.state.loginParameters.tipoLogin === 1, participante).then(result => {

      let icEventoRealizado = this.state.evento && this.state.evento.icEventoRealizado
      let icInscricaoEncerrada = !this.state.congresso.icInscricoesAbertas

      let l = this.state.loginParameters
      l.loginMessageList = []
      l.loginMessage = ''

      if (!result.data && !result.data.idCongressista) {

        if (result.data.Regra == null && (icEventoRealizado || icInscricaoEncerrada)) {

          l.loginMessageList.push(Mensagens.m27)

          if (icInscricaoEncerrada) {
            l.loginMessageList.push(Mensagens.m28)
            l.loginMessageList.push(Mensagens.m29)
          }

          this.setState({
            ...this.state,
            loginParameters: l
          })

          result.Mensagem = ''
          return result
        }
      }

      if (result.data && result.data.idCongressista) {

        this.setState({
          ...this.state,
          user: result.data,
          optionLogin: option
        }, () => {
          this.setState({
            ...this.state,
            modalOpen: false,
            eventos: [],
            loading: true,
            participante: undefined,
            loginParameters: l
          }, () => {

            if (this.state.loginParameters.tipoLogin === 1) {


              if (result.sucesso && result.data.icExistente) {
                toast.success(<Mensagem toastr
                  Header={Mensagens.m30}
                  Content={Mensagens.m31} />);
              }
              else if (result.sucesso && !result.data.icExistente) {
                toast.success(<Mensagem toastr
                  Header={Mensagens.m30}
                  Content={Mensagens.m58} />);
              }
              else
                this.handleFimInscricao(result)


            }

            this.handleSucessoLogin()
            this.carregarEventosCongressista()

          })
        })

      }
      else if (this.state.loginParameters.tipoLogin === 2) {
        result.Mensagem = Mensagens.m32
      }
      else if (option === 3 && result.data && result.data.icCadastro) {
        // é público externo e não está inscrito.                 
        this.setState({
          ...this.state,
          modalOpen: false
        }, () => {

          l.loginTitle = Mensagens.m33
          l.loginOption = 4

          this.setState({
            ...this.state,
            modalOpen: true,
            loginParameters: l,
            participante: result.data
          })

        })
      }
      return result
    })
  }

  handleFimInscricao = (result) => {
    if (result.sucesso) {
      toast.success(<Mensagem toastr
        Header={Mensagens.m24}
        Content={Mensagens.m34} />);

    }
    else {
      toast.error(<Mensagem toastr
        Header={Mensagens.m36}
        Content={Mensagens.m35} />)
    }
  }
  handleInicioInscricao = (evento) => {

    let l = this.state.loginParameters
    l.loginMessageList = []
    l.tipoLogin = 1
    l.lblBtnLogin = Mensagens.b3

    this.setState({
      ...this.state,
      loginParameters: l,
      evento: evento,
      icAvaliacaoNPS: false
    }, () => {
      if (Usuarios.isAuthenticated()) {
        Eventos.handleInscricao(evento.idEventoCongresso, '', '', 1, this.state.loginParameters.tipoLogin === 1).then(result => {

          this.setState({
            ...this.state,
            eventos: [],
            loading: true
          }, () => {
            this.carregarEventos()
            this.carregarEventosCongressista()
            this.handleFimInscricao(result)
          })
        })
      }
      else {
        l.loginOption = 0
        l.loginTitle = Mensagens.b3
        this.setState({ ...this.state, modalOpen: true, loginParameters: l })
      }
    })

  }

  handleExclusao = (evento) => {

    return Eventos.excluirInscricao(evento.idInscricaoCongresso).then(result => {

      this.setState({
        ...this.state,
        eventos: [],
        loading: true
      }, () => {
        if (result.sucesso) {
          toast.success(<Mensagem toastr
            Header=''
            Content={Mensagens.m59} />);
        }
        else {
          toast.error(<Mensagem toastr
            Header={Mensagens.m36}
            Content={Mensagens.m37} />);
        }
        this.carregarEventos()
        this.carregarEventosCongressista()

      })

    })

  }

  handleClose = () => {
    this.setState({
      ...this.state,
      modalOpen: false,
      icCadastro: false
    })
  }

  handleCertificado = (evento) => {
    let l = this.state.loginParameters
    l.loginMessageList = []
    l.tipoLogin = 2
    l.lblBtnLogin = Mensagens.b15

    this.setState({
      ...this.state,
      evento: evento,
      loginParameters: l,
      icRealizaInscricao: false
    }, () => {

      if (Usuarios.isAuthenticated()) {

        this.carregarEventosNPS()
      }
      else {
        l.loginTitle = Mensagens.m38
        this.setState({ ...this.state, modalOpen: true, loginParameters: l })
      }
    })
  }

  carregarEventosNPS = () => {

    Eventos.getEventosNPS().then(result => {
      if (result.sucesso) {

        if (result.data.eventos && result.data.eventos.length > 0) {

          if (result.data.nuEventosNaoAvaliados === 0) {
            //avaliou todos os eventos => seguir para o download
            this.iniciarDownloadCertificado()
          }
          else {

            this.setState({
              ...this.state,
              icAvaliacaoNPS: true,
              loadingEventos: true,
              eventosNPS: result.data.eventos,
              nuEventosNaoAvaliados: result.data.nuEventosNaoAvaliados,
            }, () => {

              this.setState({
                ...this.state,
                modalOpen: true,
                loadingEventos: false
              })
            })
          }
        }
        else {

          this.setState({
            ...this.state,
            icAvaliacaoNPS: true,
            loadingEventos: false,
            icSemInscricoes: true
          }, () => {

            this.setState({
              ...this.state,
              modalOpen: true,
            })
          })
        }
      } else {

        toast.error(<Mensagem toastr
          Header={Mensagens.m36}
          Content={Mensagens.m39} />)
      }

    })
  }

  handleEndAvaliacaoNPS = () => {

    this.setState({
      ...this.state,
      modalOpen: false,
      nuEventosNaoAvaliados: this.state.nuEventosNaoAvaliados - 1,
    }, () => {

      if (this.state.nuEventosNaoAvaliados <= 0) {
        this.iniciarDownloadCertificado()
      }
    })
  }

  iniciarDownloadCertificado = () => {

    let l = this.state.loginParameters
    l.tipoLogin = 0

    toast.info(<Mensagem toastr
      Header={Mensagens.m19}
      Content={Mensagens.m40} />);

    this.setState({
      ...this.state,
      loginParameters: l,
      loading: false
    }, () => {

      Eventos.getCertificado().then((result) => {

        if (result.sucesso) {
          toast.success(<Mensagem toastr
            Header=''
            Content={result.Mensagem} />);
        }
        else {
          toast.error(<Mensagem toastr
            Header={Mensagens.m36}
            Content={Mensagens.m50} />);
        }
      })

      this.handleSucessoLogin()
    })

  }
}

export default withRouter(PageEventos)


// WEBPACK FOOTER //
// ./src/PageEventos.js